import { createContext, FC, ReactNode, useContext, useMemo } from 'react';
import { MarketStatsFilterStore } from '../components/global-filters/stores';

const MarketStatsFilterContext = createContext<MarketStatsFilterStore | null>(
  null,
);

interface MarketStatsFilterProviderProps {
  children: ReactNode;
}

export const MarketStatsFilterProvider: FC<MarketStatsFilterProviderProps> = ({
  children,
}) => {
  const store = useMemo(() => new MarketStatsFilterStore(), []);

  return (
    <MarketStatsFilterContext.Provider value={store}>
      {children}
    </MarketStatsFilterContext.Provider>
  );
};

export const useMarketStatsFilter = (): MarketStatsFilterStore => {
  const store = useContext(MarketStatsFilterContext);

  if (!store) {
    throw new Error(
      'useMarketStatsFilter must be used within MarketStatsFilterProvider',
    );
  }

  return store;
};
